import React from 'react'
import { Link } from 'react-router-dom'

import image from './img/image.png'

type Props = {
    className: string
}

export const HeaderSection: React.FC<Props> = ({ className }) => {
    return (
        <div className={'p-4 justify-center ' + className}>
            <div className="flex flex-col md:flex-row w-full lg:w-[920px] p-10 gap-8 items-center rounded-lg bg-[#181818]">
                <div className="flex-1 text-white">
                    <h1 className="text-2xl font-bold">
                        АВТОМАТИЗАЦИЯ ЗАКУПОК{' '}
                        <span className="text-[#1051F5]">НОВОГО УРОВНЯ</span>
                    </h1>
                    <p className="my-8">
                        NOXSYS – современная система автоматизации закупок для
                        организаций-заказчиков, работающих по Федеральному
                        закону “О закупках товаров, работ, услуг отдельными
                        видами юридических лиц" от 18.07.2011 N 223-ФЗ
                    </p>
                    <Link
                        className="py-2 px-4 text-sm rounded-full bg-[#407bff] hover:bg-white hover:text-[#407bff] transition-colors duration-200"
                        to="/"
                    >
                        Стать клиентом
                    </Link>
                </div>
                <div className="flex-1">
                    <img src={image} alt="Баннер NoxSys" />
                </div>
            </div>
        </div>
    )
}
